import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@vertesia/ui/core';
import { Env } from '@vertesia/ui/env';
const regionLabels = {
    eu: 'EU',
    jp: 'JP',
};
export function RegionTag({ className }) {
    const region = Env.region;
    // Only show for non-US regions (US is default, no need to display)
    if (!region || region === 'us')
        return null;
    return (_jsx("div", { className: cn('text-[0.6rem] font-semibold px-1.5 rounded-3xl leading-4', 'bg-info text-white', className), children: regionLabels[region] ?? region.toUpperCase() }));
}
//# sourceMappingURL=RegionTag.js.map